import BigNumber from 'bignumber.js'
import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react'
import Countdown, {CountdownRenderProps} from 'react-countdown'
import styled, {keyframes} from 'styled-components'
import {useWallet} from 'use-wallet'
import Card from '../../../components/Card'
import CardContent from '../../../components/CardContent'
import CardIcon from '../../../components/CardIcon'
import Loader from '../../../components/Loader'
import useAllStakedValue from '../../../hooks/useAllStakedValue'
import useFarms from '../../../hooks/useFarms'
import {FarmProvider} from "../../../contexts/farm_provider/farm_provider";
import {getContract, getSC} from "../../../utils/erc20";
import {provider} from 'web3-core'
import {FarmCardChild} from "./farm_cards_child";
import {Farm} from "../../../contexts/Farms/types";
import titlelcon from '../../../assets/img/titleIcon.png'
import Spacer from "../../../components/Spacer";
import {Context as FarmsContext} from "../../../contexts/Farms";
import {UserAccoutProvider} from "../../../contexts/farm_provider/user_account_provider";


const FarmCards: React.FC = () => {
    const {farms} = useContext(FarmsContext);

    return (
        <UserAccoutProvider farms={farms}>
            <StyledCards>
                <StyledSubTitle><img src={titlelcon} alt=""/>Become an Underwriter</StyledSubTitle>

                <StyledRow>
                    {farms.map((farm, j) => (
                        <React.Fragment key={j}>
                            <FarmCard farm={farms[j]}/>
                        </React.Fragment>
                    ))}
                </StyledRow>

            </StyledCards>
        </UserAccoutProvider>
    )
};

export interface FarmCardProps {
    farm: Farm
}

const FarmCard: React.FC<FarmCardProps> = ({farm}) => {

    return (
        <StyledCardWrapper>
            <Card>
                <CardContent>
                    <StyledContent>
                        <CardIcon><img src={farm.icon} alt=""/></CardIcon>
                        <StyledTitle>{farm.name}</StyledTitle>
                        <Spacer/>
                        <FarmProvider model={farm}>
                            <FarmCardChild/>
                        </FarmProvider>
                    </StyledContent>
                </CardContent>
            </Card>
        </StyledCardWrapper>
    )
};

const RainbowLight = keyframes`
  
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`;

const StyledCardAccent = styled.div`
  background: linear-gradient(
    45deg,
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 154, 0, 1) 10%,
    rgba(208, 222, 33, 1) 20%,
    rgba(79, 220, 74, 1) 30%,
    rgba(63, 218, 216, 1) 40%,
    rgba(47, 201, 226, 1) 50%,
    rgba(28, 127, 238, 1) 60%,
    rgba(95, 21, 242, 1) 70%,
    rgba(186, 12, 248, 1) 80%,
    rgba(251, 7, 217, 1) 90%,
    rgba(255, 0, 0, 1) 100%
  );
  background-size: 300% 300%;
  animation: ${RainbowLight} 2s linear infinite;
  border-radius: 12px;
  filter: blur(6px);
  position: absolute;
  top: -2px;
  right: -2px;
  bottom: -2px;
  left: -2px;
  z-index: -1;
`;

const StyledCards = styled.div`
  width: 1000px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;


const StyledRow = styled.div`
  display: flex;
  margin-bottom: ${(props) => props.theme.spacing[4]}px;
  flex-flow: row wrap;
  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
  >div{
   &:nth-child(3n+3){
   margin-right:0;
   }
  }
`;

const StyledCardWrapper = styled.div`
  display: flex;
  width: 32%;
  margin-right:1.5%;
  position: relative;
  margin-bottom:20px;
`;

const StyledTitle = styled.h4`
  color: ${(props) => props.theme.color.c074c52};
  font-size: 24px;
  font-weight: bold;
  margin: ${(props) => props.theme.spacing[2]}px 0 0;
  padding: 0;
`;

const StyledContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const StyledSpacer = styled.div`
  height: ${(props) => props.theme.spacing[4]}px;
  width: ${(props) => props.theme.spacing[4]}px;
`;


const StyledSubTitle = styled.div`
font-size: 24px;
font-family: Arial;
font-weight: bold;
color: #1CA17E;
line-height: 36px;
display:flex;
align-items: center;
margin-bottom:10px;
>img{
display:block;
width:27px;
height:15px;
display: block;
margin-right:10px;

}
`;


export default FarmCards

/*

<Button
disabled={!poolActive}
text={poolActive ? 'Select' : undefined}
to={`/farms/${farm.id}`}
>
{/!*{!poolActive && (*!/}
{/!*<Countdown*!/}
{/!*date={new Date(startTime * 1000)}*!/}
{/!*renderer={renderer}*!/}
{/!*!/>*!/}
{/!*)}*!/}
</Button>*/
